import { render, staticRenderFns } from "./PathroutesWrapper.vue?vue&type=template&id=0ef68886&"
import script from "./PathroutesWrapper.vue?vue&type=script&lang=js&"
export * from "./PathroutesWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports